export default "__VITE_ASSET__Y6NwwQyP__"